import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, styled, Tooltip } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1.25rem',
  lineHeight: '24px',
  letterSpacing: '0.02em',
  padding: '14px 28px',
  color: theme.palette.common.white,
  borderRadius: '8px',
  textTransform: 'inherit',
  transition: 'all 150ms ease',
  boxShadow: 'none',

  '&:hover, &:active': {
    opacity: 0.8,
    boxShadow: 'none'
  },

  '&.Mui-disabled': {
    opacity: 0.4,
    cursor: 'not-allowed',
    color: theme.palette.common.white,
    backgroundColor: '#F6F6F6'
  },

  '&.MuiButton-sizeSmall': {
    fontSize: '1.125rem',
    padding: '8px 24px'
  },

  '&.MuiButton-containedSecondary': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.primary
  },

  '&.MuiButton-containedPrimary': {
    backgroundColor: theme.palette.primary.main
  },

  '&.MuiButton-outlinedSecondary': {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.action.disabled}`,
    padding: '7px 12px',
    color: theme.palette.text.primary,

    '&:hover': {
      background: theme.palette.secondary.main
    },

    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[600]
    }
  },

  '&.MuiButton-outlinedPrimary': {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  '&.MuiButton-outlinedError.MuiButton-sizeSmall': {
    color: theme.palette.error.main
  },

  '&.MuiButton-outlinedSuccess.MuiButton-sizeSmall': {
    color: theme.palette.success.main
  }
}));

export const CustomButton = ({ children, tooltip, disabled,...props }) => {
  return tooltip && disabled ?
    <Tooltip title={tooltip} arrow sx={{pointerEvents: 'auto'}}><Box component="span" data-testid="Wrapper"><StyledButton {...props} disabled={disabled}>{children}</StyledButton></Box></Tooltip> :
    <StyledButton {...props} disabled={disabled}>{children}</StyledButton>;
};

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool
};
